import moment from 'moment';

export function chartFormat(value) {
  const val = moment(value);  
  if (val.hour() == 0)
    return moment(value).utc().format("D MMM HH:mm");

  return moment(value).utc().format("D MMM HH:mm");
}


export function chartLabelFormat(value) {
  return moment(value).utc().format("HH:mm");
}